import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-gray-800">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-base text-gray-300">
            &copy; 2025 FlowLogic LLC. All rights reserved.
          </p>
          <div className="mt-4 flex items-center justify-center space-x-6">
            <Link to="/terms" className="text-sm text-gray-400 hover:text-gray-200">
              Terms of Service
            </Link>
            <span className="text-gray-500">•</span>
            <Link to="/privacy" className="text-sm text-gray-400 hover:text-gray-200">
              Privacy Policy
            </Link>
            <span className="text-gray-500">•</span>
            <Link to="/security" className="text-sm text-gray-400 hover:text-gray-200">
              Security
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}